import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useIntercom } from "react-use-intercom";

import {
  AccordionWrapper,
  AnswerText,
  AnswerWrapper,
  Header,
  IntercomSubTitle,
  IntercomTextWrapper,
  IntercomTitle,
  IntercomWrapper,
  LI,
  PageTitle,
  PageWrapper,
  QuestionItem,
  QuestionSection,
  SectionItem,
  SectionTitle,
  SubTitle,
} from "./style";
import { FlexDiv, SVGSprite } from "@/components/Atoms";
import { AccordionV2 } from "@/components/Atoms/Accordion/V2";
import { data } from "./data";
import { UL } from "@/containers/WellnessPrograms/AllPackages/style";
import useDisableIntercom from "@/hooks/useDisableIntercom";

function YogaFaqsPageForApp() {
  const router = useRouter();
  // Commented intercom due to freshchat integration
  // const { boot } = useIntercom();
  // useDisableIntercom({});

  // const {
  //   talk_to_coach = "",
  //   talk_to_nutritionist = "",
  //   customer_key = "",
  // } = router.query;

  // useEffect(() => {
  //   const intercomData = {
  //     talk_to_coach,
  //     talk_to_nutritionist,
  //     customer_key,
  //   };

  //   boot({ customAttributes: intercomData });
  // }, []);

  // const handleIntercomClick = () => {
  //   window.Intercom && window.Intercom("show");
  // };

  return (
    <FlexDiv width="100%" justifyContent="center">
      <PageWrapper>
        <Header>
          <PageTitle variant="heading1">We are here to help!</PageTitle>
          <SubTitle variant="paragraph1">
            Find the right responses to all your doubts and queries about our
            Yoga packs below.
          </SubTitle>
        </Header>
        <QuestionSection>
          {data.map(({ sectionTitle, questionsList }) => {
            return (
              <>
                <SectionItem>
                  <SectionTitle variant="heading4">{sectionTitle}</SectionTitle>
                  <AccordionWrapper>
                    {questionsList?.map(({ questionText, type, ...rest }) => {
                      return (
                        <QuestionItem>
                          <AccordionV2 title={questionText}>
                            {type === "type1" && Type1(rest)}
                            {type === "type2" && Type2(rest)}
                          </AccordionV2>
                        </QuestionItem>
                      );
                    })}
                  </AccordionWrapper>
                </SectionItem>
              </>
            );
          })}
        </QuestionSection>

        {/* <FlexDiv
          style={{
            padding: "16px 16px 40px 16px",
            width: "100%",
            cursor: "pointer",
            marginTop: "16px",
          }}
        >
          <IntercomWrapper onClick={handleIntercomClick}>
            <SVGSprite
              icon="icon-message-question"
              width="42px"
              height="42px"
            />
            <IntercomTextWrapper>
              <IntercomTitle variant="heading3">
                Didn’t find what you are looking for?
              </IntercomTitle>

              <IntercomSubTitle variant="paragraph1">
                Chat with our support team
              </IntercomSubTitle>
            </IntercomTextWrapper>
          </IntercomWrapper>
        </FlexDiv> */}
      </PageWrapper>
    </FlexDiv>
  );
}

const Type1 = ({ headerText, footerText, bulletPoints }: any) => {
  return (
    <AnswerWrapper>
      {headerText?.length > 0 &&
        headerText?.map((text: string) => {
          return <AnswerText variant="paragraph1">{text}</AnswerText>;
        })}

      {bulletPoints?.length > 0 && (
        <UL>
          {bulletPoints?.map((text: string) => {
            return (
              <LI>
                <AnswerText variant="paragraph1">{text}</AnswerText>
              </LI>
            );
          })}
        </UL>
      )}
      {footerText?.length > 0 &&
        footerText?.map((text: string) => {
          return (
            <AnswerText
              variant="paragraph1"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          );
        })}
    </AnswerWrapper>
  );
};

const Type2 = ({ headerText, sectionData }: any) => {
  return (
    <AnswerWrapper>
      {headerText?.length > 0 &&
        headerText?.map((text: string) => {
          return <AnswerText variant="paragraph1">{text}</AnswerText>;
        })}

      {sectionData.map(({ sectionHeading, bulletPoints }: any) => {
        return (
          <>
            <AnswerText
              variant="paragraph1"
              dangerouslySetInnerHTML={{ __html: sectionHeading }}
            />
            {bulletPoints?.length > 0 && (
              <UL>
                {bulletPoints?.map((text: string) => {
                  return (
                    <LI>
                      <AnswerText variant="paragraph1">{text}</AnswerText>
                    </LI>
                  );
                })}
              </UL>
            )}
          </>
        );
      })}
    </AnswerWrapper>
  );
};

export default YogaFaqsPageForApp;
